import api from "@/api";
import { paths } from "@/router";

const url = new URL(location.href);
const searchParams = url.searchParams;

const state = {
  deviceName: {
    dr001: "Black Diamond 75",
    cb_matrix: "CYBERBOARD MATRIX",
    "65les": "AM 65 LESS",
    hatsu: "HATSU",
    am21: "AM Relic 80",
    cb_terminal: "CYBERBOARD Terminal",
    cb03: "CyberBoard_II",
    cb04: "CYBERBOARD",
    cb02: "LE SMOKING",
    alice: "AM AFA",
    cyberblade: "CYBERBLADE",
    dongle: "AngryMiao dongle",
    am_28: "AM RGB 65",
    "65les_r2": "AM 65 LESS R2",
    "65les_r1": "AM 65 LESS R1",
    dr002: "PETBRICK 65",
    mouse: "AM INFINITY MOUSE",
    mousedongle: "AM INFINITY MOUSE",

    MOUSE: "Angrymiao Mouse",
    DR001: "Black Diamond 75",
    CB_MATRIX: "CYBERBOARD MATRIX",
    "65LES": "AM 65 LESS",
    HATSU: "HATSU",
    AM21: "AM Relic 80",
    CB_TERMINAL: "CYBERBOARD Terminal",
    CB03: "CyberBoard_II",
    CB04: "CYBERBOARD",
    CB02: "LE SMOKING",
    ALICE: "AM AFA",
    CYBERBLADE: "CYBERBLADE",
    DONGLE: "AngryMiao dongle",
    AM_28: "AM RGB 65",
    "65LES_R2": "AM 65 LESS R2",
    "65LES_R1": "AM 65 LESS R1",
    DR002: "PETBRICK 65",
    MOUSE: "AM INFINITY MOUSE",
    MOUSEDONGLE: "AM INFINITY MOUSE",
  },
  loading: false,
  inLoader: searchParams.get("inLoader") === "true" || !!window.qt,
  isQT: !!window.qt,
  bridge: null,
  systemInfo: {
    deviceList: [],
    version: "", // 固件版本
    isLatestVersion: true, // 固件版本是否为最新版
    updateDescription: {
      zh_CN: "",
      en_US: "",
    },
    password: "135qwr", // 实验室密码，用于手动加载固件
    language: "",
  },
  currentDevice: {
    port: "",
    code: "",
    updateDescription: { zh_CN: "", en_US: "" },
  },
  activeDeviceIndex: 0,
};

let timer = 0;

const actions = {
  setLoading({ commit }, data) {
    let loading;
    let time = 7000;
    if (typeof data === "boolean") {
      loading = data;
    } else {
      loading = data.loading;
      time = data.time;
    }
    if (loading) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        commit("SET_LOADING", false);
      }, time);
    }
    commit("SET_LOADING", loading);
  },
  setInLoader({ commit }, inLoader) {
    commit("SET_IN_LOADER", inLoader);
  },
  setBridge({ commit }, bridge) {
    commit("SET_BRIDGE", bridge);
  },
  aiChat(context, data) {
    return api.chat(data);
  },
  setDeviceName({ commit }, deviceName) {
    for (const key in deviceName) {
      deviceName[key.toLowerCase()] = deviceName[key];
    }
    commit("SET_DEVICE_NAME", deviceName);
  },
  setSystemInfo({ commit, dispatch }, systemInfo) {
    systemInfo.deviceList = systemInfo.deviceList.map((device) => ({
      ...device,
      code: device.code.toLowerCase(),
    }));
    commit("SET_LOADER_INFO", systemInfo);
    dispatch("app/setLanguage", systemInfo.language, { root: true });
  },
  getSystemInfo({ state }) {
    console.log("Bridge", "getSystemInfo");
    if (!state.bridge) return;
    state.bridge.getSystemInfo();
  },
  getDongle({ state }, json) {
    console.log("Bridge", "getDongle", json);
    if (!state.bridge) return;
    state.bridge.getDongle(JSON.stringify(json));
  },
  updateDongle({ state }, json) {
    console.log("Bridge", "updateDongle", json);
    if (!state.bridge) return;
    state.bridge.updateDongle(JSON.stringify(json));
  },
  pairDongle({ state }, json) {
    console.log("Bridge", "pairDongle", json);
    if (!state.bridge) return;
    state.bridge.pairDongle(JSON.stringify(json));
  },
  openCommunity({ state }) {
    console.log("Bridge", "openCommunity");
    if (!state.bridge) return;
    state.bridge.openCommunity();
  },
  setLanguage({ state }, language) {
    console.log("Bridge", "setLanguage", language);
    if (!state.bridge) return;
    state.bridge.setLanguage(language);
  },
  setCurrentDevice({ commit, state }, device) {
    device = {
      ...device,
      code: device.code.toLowerCase(),
    };
    commit("SET_CURRENT_DEVICE", device);
    console.log("Bridge", "setCurrentDevice", device);
    if (!state.bridge) return;
    state.bridge.setCurrentDevice(JSON.stringify(device));
  },
  setActiveDeviceIndex({ commit }, index) {
    commit("SET_ACTIVE_DEVICE_INDEX", index);
  },
  updateLoader({ state }) {
    console.log("Bridge", "updateLoader");
    if (!state.bridge) return;
    state.bridge.updateLoader();
  },
  restartLoader({ state }) {
    console.log("Bridge", "restartLoader");
    if (!state.bridge) return;
    state.bridge.restartLoader();
  },
  updateFirmware({ state }) {
    console.log("Bridge", "updateFirmware");
    if (!state.bridge) return;
    state.bridge.updateFirmware();
  },
  loadFirmware({ state }) {
    console.log("Bridge", "loadFirmware");
    if (!state.bridge) return;
    state.bridge.loadFirmware();
  },
  loadJson({ state }) {
    console.log("Bridge", "loadJson");
    if (!state.bridge) return;
    state.bridge.loadJson();
  },
  downloadJSON({ state }, json) {
    console.log("Bridge", "downloadJSON", "End", json);
    if (!state.bridge) return;
    state.bridge.downloadJSON(JSON.stringify(json));
  },
  syncMacroKey({ state, commit }, json) {
    console.log("Bridge", "syncMacroKey", json);
    if (!state.bridge) return;
    state.bridge.syncMacroKey(JSON.stringify(json));
    // setTimeout(() => {
    commit("SET_LOADING", true);
    // }, 100);
  },
  syncJSON({ state }) {
    console.log("Bridge", "syncJSON");
    if (!state.bridge) return;
    state.bridge.syncJSON();
  },
  resetJSON({ state }) {
    console.log("Bridge", "resetJSON");
    if (!state.bridge) return;
    state.bridge.resetJSON("reset");
  },
  downloadFile({ state }, json) {
    console.log("Bridge", "downloadFile", json);
    if (!state.bridge) return;
    state.bridge.downloadFile(JSON.stringify(json));
  },
  transportMode({ state }) {
    console.log("Bridge", "transportMode");
    if (!state.bridge) return;
    state.bridge.transport_mode();
  },
  initMouseData({ state }) {
    console.log("Bridge", "initMouseData");
    if (!state.bridge) {
      window.location.href = paths.mouseConnect;
      return;
    }
    state.bridge.initMouseData();
  },
  getElectricity({ state }) {
    console.log("Bridge", "getElectricity");
    if (!state.bridge) return;
    state.bridge.getElectricity();
  },
  mouseReset({ state }) {
    console.log("Bridge", "mouseReset");
    if (!state.bridge) return;
    state.bridge.resetMouse();
  },
  changeMouseKey({ state }, json) {
    console.log("Bridge", "changeMouseKey", json);
    if (!state.bridge) return;
    state.bridge.changeMouseKey(JSON.stringify(json));
  },
  getMouseDPI({ state }) {
    console.log("Bridge", "getMouseDPI");
    if (!state.bridge) return;
    state.bridge.getMouseDPI();
  },
  setMouseDPI({ state }, json) {
    console.log("Bridge", "setMouseDPI", json);
    if (!state.bridge) return;
    state.bridge.setMouseDPI(JSON.stringify(json));
  },
  getMouseInfo({ state }) {
    console.log("Bridge", "getMouseInfo");
    if (!state.bridge) return;
    state.bridge.getMouseInfo();
  },
  setMouseInfo({ state }, json) {
    console.log("Bridge", "setMouseInfo", json);
    if (!state.bridge) return;
    state.bridge.setMouseInfo(JSON.stringify(json));
  },
  getMouseMacro({ state }) {
    console.log("Bridge", "getMouseMacro");
    if (!state.bridge) return;
    state.bridge.getMouseMacro();
  },
  saveMouseMacro({ state }, json) {
    console.log("Bridge", "saveMouseMacro", json);
    if (!state.bridge) return;
    state.bridge.saveMouseMacro(JSON.stringify(json));
  },
  deleteMouseMacro({ state }, json) {
    console.log("Bridge", "deleteMouseMacro", json);
    if (!state.bridge) return;
    state.bridge.deleteMouseMacro(JSON.stringify(json));
  },
  setMouseMacro({ state }, json) {
    console.log("Bridge", "setMouseMacro", json);
    if (!state.bridge) return;
    state.bridge.setMouseMacro(JSON.stringify(json));
  },
  resetMagnetKey({ state }) {
    console.log("Bridge", "resetMagnetKey");
    if (!state.bridge) return;
    state.bridge.resetMagnetKey();
  },
  getMouseSet({ state }, layer) {
    console.log("Bridge", "getMouseSet", layer);
    if (!state.bridge) return;
    state.bridge.getMouseSet(layer);
  },
  autoMouseUpdate({ state }, type) {
    console.log("Bridge", "autoMouseUpdate", type);
    if (!state.bridge) return;
    state.bridge.autoMouseUpdate(JSON.stringify({ up_type: type }));
  },
  localMouseUpdate({ state }, type) {
    console.log("Bridge", "localMouseUpdate", type);
    if (!state.bridge) return;
    state.bridge.localMouseUpdate(JSON.stringify({ up_type: type }));
  },
  getCurrentVer({ state }) {
    console.log("Bridge", "getCurrentVer");
    if (!state.bridge) {
      window.location.href = paths.mouseConnect;
      return;
    }
    state.bridge.getCurrentVer();
  },
  clearBlue({ state }) {
    console.log("Bridge", "clearBlue");
    if (!state.bridge) return;
    state.bridge.clearBlue();
  },
  loadMousejson({ state }) {
    console.log("Bridge", "loadMousejson");
    if (!state.bridge) return;
    state.bridge.loadMousejson();
  },
  saveMousejson({ state }, json) {
    console.log("Bridge", "saveMousejson", json);
    if (!state.bridge) return;
    state.bridge.saveMousejson(JSON.stringify(json));
  },
  getMDLight({ state }) {
    console.log("Bridge", "getMDLight");
    if (!state.bridge) return;
    state.bridge.getMDLight();
  },
  setMDLight({ state }, json) {
    console.log("Bridge", "setMDLight", json);
    if (!state.bridge) return;
    state.bridge.setMDLight(JSON.stringify(json));
  },
  getKeyLight({ state }, json) {
    console.log("Bridge", "getKeyLight", json);
    if (!state.bridge) return;
    state.bridge.getKeyLight(JSON.stringify(json));
  },
  sendKeyLight({ state }, json) {
    console.log("Bridge", "sendKeyLight", json);
    if (!state.bridge) return;
    state.bridge.sendKeyLight(JSON.stringify(json));
  },
  getKeySystem({ state }, json) {
    console.log("Bridge", "getSys", json);
    if (!state.bridge) return;
    state.bridge.getSys(JSON.stringify(json));
  },
  setKeySystem({ state }, json) {
    console.log("Bridge", "setSys", json);
    if (!state.bridge) return;
    state.bridge.setSys(JSON.stringify(json));
  },
};

const mutations = {
  SET_LOADING: (state, loading) => {
    state.loading = loading;
  },
  SET_IN_LOADER: (state, inLoader) => {
    state.inLoader = inLoader;
  },
  SET_BRIDGE: (state, bridge) => {
    state.bridge = bridge;
  },
  SET_DEVICE_NAME: (state, deviceName) => {
    state.deviceName = deviceName;
  },
  SET_LOADER_INFO: (state, systemInfo) => {
    state.systemInfo = systemInfo;
  },
  SET_CURRENT_DEVICE: (state, device) => {
    state.currentDevice = device;
  },
  SET_ACTIVE_DEVICE_INDEX: (state, index) => {
    state.activeDeviceIndex = index;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
